export const countInitialValue = (value: number, duration: number): number => {
  const initialValue = value - (duration / 30000) * 0.6;
  return initialValue < 0 ? 0 : initialValue;
};

export const calculatePresentedValue = (
  timeDiff: number,
  duration: number,
  previousValue: number,
  targetValue: number
) =>
  timeDiff >= duration
    ? targetValue
    : Math.floor(
        (previousValue +
          (targetValue - previousValue) * (timeDiff / duration)) *
          100
      ) / 100;

export const getDisplayedDecimalsAmount = (value: number) => {
  const stringOfValue = String(Math.floor(value));
  if (stringOfValue.length <= 7) {
    return 2;
  }
  if (stringOfValue.length === 8) {
    return 1;
  }
  return 0;
};
